import { Crop } from 'react-image-crop';
import { createCustomAction } from 'typesafe-actions';

import { Size } from '../../typings/common';
import { CreativeImageData } from '../common/typings';

import { CreativeImageCropValue } from './typings';

export const openModal = createCustomAction('@canvasCreativeSmartCenterModal/OPEN', type => {
    return (imageData: CreativeImageData, origSrc: string, cropValue?: CreativeImageCropValue) => ({
        type,
        origSrc,
        imageData,
        cropValue
    });
});

export const init = createCustomAction('@canvasCreativeSmartCenterModal/INIT', type => {
    return (imageData: CreativeImageData, cropValue?: CreativeImageCropValue) => ({
        type,
        imageData,
        cropValue
    });
});

export const closeModal = createCustomAction('@canvasCreativeSmartCenterModal/CLOSE');

export const cropComplete = createCustomAction('@canvasCreativeSmartCenterModal/CROP_COMPLETE', type => {
    return (crop: Crop) => ({ type, crop });
});

export const saveModal = createCustomAction('@canvasCreativeSmartCenterModal/SAVE', type => {
    return (image: HTMLImageElement) => ({ type, image });
});

export const showError = createCustomAction('@canvasCreativeSmartCenterModal/SHOW_ERROR', type => {
    return (message?: string) => ({
        type,
        message
    });
});

export const setImageSize = createCustomAction('@canvasCreativeSmartCenterModal/SET_IMAGE_SIZE', type => {
    return (naturalImageSize: Size, imageSize: Size) => ({
        type,
        naturalImageSize,
        imageSize
    });
});

export type OpenModalAction = ReturnType<typeof openModal>;
export type SaveModalAction = ReturnType<typeof saveModal>;

export type CreativeSmartCenterModalAction =
    | ReturnType<typeof closeModal>
    | ReturnType<typeof init>
    | ReturnType<typeof cropComplete>
    | ReturnType<typeof setImageSize>
    | ReturnType<typeof showError>
    | OpenModalAction
    | SaveModalAction;
